import { FC, PropsWithChildren } from 'react';

import { useMitarbeiterRole } from '../api/auth.hook';
import { MitarbeiterRole } from '../api/types';

interface VisibleIfRoleProps {
  equals: MitarbeiterRole;
}

export const VisibleIfRole: FC<PropsWithChildren<VisibleIfRoleProps>> = props => {
  const userRole = useMitarbeiterRole();
  return <>{props.equals === userRole && props.children}</>;
};
